import script from "./NewFan.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFan.vue?vue&type=script&setup=true&lang=js"

import "./NewFan.vue?vue&type=style&index=0&id=25b3d0fb&scoped=true&lang=css"
import "./NewFan.vue?vue&type=style&index=1&id=25b3d0fb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b3d0fb"]])

export default __exports__